export { default } from './euras-marriage-documents';
